export const providers = [
    { name: "Google", icon: "flat-color-icons:google" },
    { name: "Discord", icon: "pajamas:discord" },
    { name: "GitHub", icon: "mdi:github" }
];